export default "__VITE_ASSET__DNINVLxG__"